import {
    RECEIVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILES,
    REMOVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE,
    REQUEST_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILES,
} from '../actions'
import { updateOrAddItemsById } from '../helpers'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: false,
        items: [],
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILES:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILES: {
            const { items: currentItems } = state
            const { items: receivedItems } = data

            const items = updateOrAddItemsById({ currentItems, receivedItems })

            return {
                ...state,
                ...data,
                items,
            }
        }

        case REMOVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE: {
            const { items: currentItems } = state
            const { id } = data

            const items = currentItems.filter((o) => o.id !== id)

            return {
                ...state,
                items,
            }
        }

        default:
            return state
    }
}
